import { HeartPulse } from 'lucide-react';
import styles from './BrandMark.module.css';

export function BrandMark({ tone = 'light' }: { tone?: 'light' | 'dark' }) {
  return (
    <span className={styles.brand} data-tone={tone}>
      <span className={styles.mark} aria-hidden="true"><HeartPulse className={styles.glyph} strokeWidth={2.5} /></span>
      <span className={styles.word}>PAIN<span className={styles.pal}>PAL</span></span>
    </span>
  );
}
